import React from 'react';
import './Logo.css';

const Logo = ({ size = 'medium', className = '' }) => {
  // Usar a imagem dark da pasta public
  const logoPath = '/logo-cantinho.png';
  
  const sizes = {
    small: { width: '120px', height: 'auto' },
    medium: { width: '180px', height: 'auto' },
    large: { width: '240px', height: 'auto' }
  };

  const dimensions = sizes[size] || sizes.medium;

  return (
    <div className={`logo-container ${className}`}>
      <img 
        src={logoPath}
        alt="Cantinho do Sabor"
        style={dimensions}
        className="logo-img"
      />
    </div>
  );
};

export default Logo;
